module.exports = __webpack_public_path__ + "img/galeria-acuariofilia-2.e5b15d62.jpg";